import { resize } from '@wix/thumbnail-generator';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
import { WIX_VIDEO_LIBRARY_LINK } from '../data';
export const fromVideotoItem = (item, token) => {
  return {
    ...item,
    kind: ItemKind.File,
    mediaType: MediaType.Video,
    id: item.item_id,
    source: 'wixVideo',
    name: item.title,
    thumbnailUrl: item.cover_url && resize(item.cover_url).replace('/file.jpg', ''),
    fileSize: item.file_size,
    folderId: JSON.stringify({
      siteMediaToken: token,
      id: WIX_VIDEO_LIBRARY_LINK
    }),
    createdAt: Date.parse(item.created_at)
  };
};